import { render, staticRenderFns } from "./DetailedFormImg.vue?vue&type=template&id=72a39bb8&scoped=true&"
import script from "./DetailedFormImg.vue?vue&type=script&lang=js&"
export * from "./DetailedFormImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a39bb8",
  null
  
)

export default component.exports